import axios from "axios";

export const deleteInvoice = async (body) => {
  const data = JSON.stringify(body);
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';
  
  const config = {
    method: "POST",
    url: `http://${url}:4000/api/v1/boletaDigital/deleteInvoice`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    const { response } = error;
    return response;
  }
};
